/**
 * Safely extract a human-readable error message from an axios error.
 *
 * Avoids the React crash "Objects are not valid as a React child" that
 * occurs when FastAPI returns Pydantic validation errors as
 * `detail: [{type, loc, msg, ...}]` and the caller passes that directly
 * to `toast.error()`.
 *
 * Usage:
 *   } catch (err) {
 *     toast.error(extractErrorMessage(err, 'Erreur'));
 *   }
 */
export function extractErrorMessage(error, fallback = 'Erreur') {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    if (typeof first === 'string') return first;
    if (first && typeof first.msg === 'string') return first.msg;
  }
  if (typeof error?.message === 'string') return error.message;
  return fallback;
}
